<template>
    <b-tabs pills card vertical class="">
        <b-tab title-link-class="" :key="idx" :active="provider.is_active" v-for="(provider,idx) in providers">
            <template slot="title">
                <div class="fs-lg px-4 text-center ">
                    {{provider.title}}
                </div>
            </template>
            <b-card-text>
                <component v-bind:rest="rest" v-bind:is="provider.type" :provider="provider"></component>
            </b-card-text>
        </b-tab>
    </b-tabs>
</template>

<script>
import order_notification_channel from "./order_notification/order_notification_channel.vue";

export default {
    name: "restaurant_notification",
    components : {
        sms: order_notification_channel,
        turbosms: order_notification_channel,
        tg: order_notification_channel,
    },
    props : {
        rest : {
            type : Object
        }
    },
    data() {
        return {
            is_load: true,
            providers : []
        }
    },
    created() {
        this.load_types();
        this.load_notifications(this.rest.id);
    },
    methods : {
        load_types() {
            notification_api.get('/order_notification/types').then(({data}) => {
                if (data.status === "operation_success") {
                    this.providers = data.data.map((item,idx) => ({
                        type: item.type,
                        title: item.title,
                        is_active: idx === 0,
                    }));
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        },

        load_notifications(rest_id) {
            this.is_load = true;

            notification_api.get('/order_notification/restaurant/' + rest_id).then(({data}) => {
                if (data.status === "operation_success") {
                    this.$set(this.rest, 'order_notification', data.data);
                }
                this.is_load = false;
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        },
    },
}
</script>

<style scoped>

</style>
